import { ComponentVersionsInherit, ComponentVersions_3_0, Skeleton, styled } from 'opensolar-ui'

const Container = styled('div')({
  width: '100%',
  boxSizing: 'border-box',
})

const Header = styled('div')({
  display: 'flex',
  width: '100%',
  height: '76px',
  background: 'white',
  justifyContent: 'center',
  alignItems: 'center',
})

const PageContainer = styled('div')({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  background: '#F6F9FC',
})

const InnerPageContainer = styled('div')({
  display: 'flex',
  maxWidth: '1440px',
  padding: '40px 28px',
  flexDirection: 'row',
  boxSizing: 'border-box',
  width: '100%',
})

const LeftColumnContainer = styled('div')({
  display: 'flex',
  flexBasis: '66%',
  flexDirection: 'column',
  gap: '12px',
  padding: '0 12px',
})

const RightColumnContainer = styled('div')({
  display: 'flex',
  flexBasis: '34%',
  flexDirection: 'column',
  gap: '24px',
  padding: '0 12px',
})

const SectionContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  background: 'white',
  borderRadius: '8px',
  boxSizing: 'border-box',
  gap: 24,
})

const FieldContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
})

const FieldRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  width: '100%',
  maxWidth: 640,
})

export const CheckoutLoadingPage = () => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Container>
        <Header>
          <Skeleton width={390} height={50} />
        </Header>
        <PageContainer>
          <InnerPageContainer>
            <LeftColumnContainer>
              <Section height={569}>
                <Skeleton width="15%" height={30} />
                <Field />
                <FieldRow>
                  <Field />
                  <Field />
                </FieldRow>
                <FieldRow>
                  <Field />
                  <Field />
                </FieldRow>
                <FieldRow>
                  <Field width="50%" />
                </FieldRow>
              </Section>
              <Section height={2417}>
                <Skeleton width="100%" height={30} />
                <Skeleton width="80%" height={30} />
              </Section>
            </LeftColumnContainer>
            <RightColumnContainer>
              <Section>
                <Skeleton width="15%" height={30} />
                <FieldRow style={{ justifyContent: 'space-between' }}>
                  <Skeleton width={120} height={30} />
                  <Skeleton width={160} height={30} />
                </FieldRow>
                <FieldRow style={{ justifyContent: 'space-between' }}>
                  <Skeleton width={120} height={30} />
                  <Skeleton width={160} height={30} />
                </FieldRow>
                <div />
                <Skeleton width="15%" height={30} />
                <FieldRow style={{ justifyContent: 'space-between' }}>
                  <Skeleton width={120} height={30} />
                  <Skeleton width={160} height={30} />
                </FieldRow>
                <FieldRow style={{ justifyContent: 'space-between' }}>
                  <Skeleton width={120} height={30} />
                  <Skeleton width={160} height={30} />
                </FieldRow>
                <Skeleton width="100%" height={30} />
                <Skeleton width="80%" height={30} style={{ alignSelf: 'center' }} />
              </Section>
              <Section />
            </RightColumnContainer>
          </InnerPageContainer>
        </PageContainer>
      </Container>
    </ComponentVersionsInherit>
  )
}

const Section = ({ height, children }: { height?: number; children?: React.ReactNode }) => {
  return (
    <SectionContainer style={{ minHeight: height ? `${height}px` : undefined }}>
      <Skeleton width={200} height={30} />
      {children}
    </SectionContainer>
  )
}

const Field = ({ width = '100%' }: { width?: string }) => {
  return (
    <FieldContainer style={{ width }}>
      <Skeleton width={70} height={16} />
      <Skeleton width="100%" height={30} />
    </FieldContainer>
  )
}
